import { Button, ButtonGroup, ButtonVariant, Icon, Intent, Popover, Size } from "@blueprintjs/core"
import { useEffect, useRef, useState } from "react"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { Hint, ScalableDialog } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { ILink } from "src/modules/pe-landing-module/data/interfaces"
import { AddItem } from "../../landing-edit/editors/ItemEditor"
import { LinkEditForm } from "../../landing-edit/editors/link/SingleLinkDialog"

/* Protopia Ecosystem component */
export interface ILinkItemEditFormProps {
    isNew?: boolean
    i: number
    item: ILink
    items: ILink[]
    onAdd?: ( item: ILink ) => void 
    onUpdate?: ( item: ILink ) => void 
    doDelete?: () => void 
}
const LinkItemEditForm = (props: ILinkItemEditFormProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null) 
    const [ isOpen, setIsOpen ]         = useState<boolean>(false)
    const [ isLoading, setIsLoading ]   = useState<boolean>(false)
    const [item, setItem]               = useState<ILink>(props.item)
    useEffect(() => {
        setItem(props.item)
    }, [ props.item ])
    const onAdd = () => {

    }
    const doDelete = () => {
        if(props.doDelete) props.doDelete()
    }
    const onNext = () => {

    }
    const onEdit = () => {
        setIsOpen( true ) 
    }
    const onClose = () => {
        setIsOpen( false ) 
    }
    const onEditItem = ( val: any, field: string, dop: any ) => {
        setItem( {
            ...item,
            [field]: val
        })
    }
    const onUpdate = () => {
        if( props.onUpdate) props.onUpdate( item)
        onClose() 
    }
    const ICON_SIZE = 12
    return <>
        <ButtonGroup className='pe-item-editor pe-surface' ref={ref} data-select-type="ignore">
            {
                props.i > 0 && <Hint label={__("Switch previous")} >
                    <Button size={Size.SMALL} variant={ButtonVariant.SOLID} >
                        <Icon icon="arrow-left" size={ICON_SIZE} />
                    </Button>
                </Hint>
            } 
            <Hint label={__("Edit")} >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={onEdit} >
                    <Icon icon="edit" size={ICON_SIZE} />
                </Button>
            </Hint>
            <Hint label={__("Add after")} >
            { 
                    props.onAdd
                        ?
                        <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={ () => { console.log(item); props.onAdd!( item ); }}>
                            <Icon icon="plus" size={ ICON_SIZE } /> 
                        </Button>
                        :
                        <Popover
                            content={ <AddItem onAdd={ onAdd } /> }
                        >
                            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} >
                                <Icon icon="plus" size={ICON_SIZE} />
                            </Button>
                        </Popover>
                }
            </Hint> 
            <Hint label={__("Delete")}  >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={doDelete}>
                    <Icon icon="trash" size={ICON_SIZE} />
                </Button>
            </Hint>
            {
                props.i < props.items.length - 1 && <Hint label={__("Switch next")} >
                    <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={onNext}>
                        <Icon icon="arrow-right" size={12} />
                    </Button>
                </Hint>
            }
        </ButtonGroup>
        <ScalableDialog
            isOpen={ isOpen }
            onClose={ onClose }
            dialogSize={ DIALOG_SIZE.NORMAL }
            footer={
                <ButtonGroup size={ Size.LARGE } fill>
                    <Button intent={ Intent.DANGER } icon="cross" onClick={ onClose } fill={ false } >
                        
                    </Button>
                    <Button intent={ Intent.SUCCESS } fill onClick={ onUpdate } >
                        { __( "Update" ) }
                    </Button>
                </ButtonGroup>
            }
        >
            { isOpen && <LinkEditForm 
                value={ item } 
                onChange={ onEditItem }
                setIsLoading={ setIsLoading } 
                isLoading={ isLoading } 
            /> }
        </ScalableDialog>
    </>
}
export default LinkItemEditForm


export interface ILinkEditFormProps {
    isEdit: boolean
    item: ILink
    onEdit: (item: ILink) => void
}
export const LinkEditForm2 = (props: ILinkEditFormProps) : JSX.Element => {
    return props.isEdit 
        ?
        <div className="max-height flex-grow-100 overflow-y-auto">
            <div className="p-4">
                { props.item.url }
            </div> 
        </div>
        :
        <></>
}